import { ButtonHTMLAttributes, FC } from 'react'
import classNames from 'classnames'
import SvgClose from '../icons/Close'
import './ModalCloseButton.scss'

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  close: () => void
}

export const ModalCloseButton: FC<Props> = ({ close, className, ...attrs }) => {
  return (
    <button className={classNames('ModalCloseButton', className)} {...attrs} onClick={close}>
      <SvgClose />
    </button>
  )
}
